<template>
  <div class="modify-page">
    <navigation
      class="header"
      :theme="{
        background: '#fff',
      }"
    >信息修改
    </navigation>
    <div class="form-container" v-if="showProvide">
      <div class="divider"></div>
      <div class="step-title">
        <img src="./images/img_step02@2x.png" />
        <h2>补充资料：<template v-if="mobileChangeInfo.mobile">手机号</template><template  v-if="mobileChangeInfo.mobile && contactsChangeInfo && contactsChangeInfo.length">/</template><template v-if="contactsChangeInfo && contactsChangeInfo.length">联系人</template>修改</h2>
        <p>为确认您为本人操作，请补充以下资料</p>
      </div>
      <div class="add-list">
        <div class="item" v-if="showCard">
          <nd-cell
            :class="['row-item', { 'gray-text': cardReady }]"
            title="身份信息"
            :arrow="cardReady?false:true"
            :text="!cardReady ? '去补充' : '已补充'"
            @click="cardReady?'':$router.push('/modify/addId')"
          ></nd-cell>
        </div>
        <div class="item" v-if="showOther">
          <nd-cell
            :class="['row-item', { 'gray-text': otherReady }]"
            title="其他资料"
            :arrow="otherReady?false:true"
            @click="otherReady?'':$router.push('/modify/addOther')"
            :text="!otherReady ? '去补充' : '已补充'"
          ></nd-cell>
        </div>
      </div>
    </div>

    <div class="form-container" v-else>
      <div class="divider"></div>
      <div class="step-title">
        <img src="./images/img_step02@2x.png" />
        <h2>补充资料：<template v-if="mobileChangeInfo.mobile">手机号</template><template  v-if="mobileChangeInfo.mobile && contactsChangeInfo && contactsChangeInfo.length">/</template><template v-if="contactsChangeInfo && contactsChangeInfo.length">联系人</template>修改</h2>
      </div>
 
      <img src="./images/img_001@2x.png" class="info-img">
    </div>


    <div class="control-box">
      <nd-button class="btn" :disabled="disable" @click="next">确认提交</nd-button>
      <div class="protocol">
        <span class="text">
          <p class="indent">
            <img
              src="./images/circle_02.png"
              v-if="selected"
              @click="selected = false"
            />
            <img src="./images/circle_01.png" v-else @click="selected = true" />
          </p>
          <div>
            <span>点击「确认提交」前请知晓并同意 </span>
            <span class="active" @click="$router.push('/modify/protocol')">《天美贷用户信息变更申请书》</span>
          </div>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      selected: false,
      needProvide: [],
      hasProvide: [],
      mobileChangeInfo: {},
      contactsChangeInfo: []
    }
  },

  mounted () {
    this.getConfig()
    this.$bus.$emit('ready')
  },
  computed: {
    disable () {
      return !this.selected || (this.showCard && !this.cardReady) || (this.showOther && !this.otherReady)
    },
    showProvide () {
      return ['ID_CARD_FRONT', 'ID_CARD_BACK', 'HOLDING_ID_CARD_PHOTO', 'PAYMENT_CARD_PHOTO', 'LOAN_HISTORY_SCREEN'].some(item => {
        return this.needProvide.includes(item)
      })
    },
    cardReady () {
      return this.needProvide.filter(ai => ['ID_CARD_FRONT', 'ID_CARD_BACK', 'HOLDING_ID_CARD_PHOTO'].includes(ai)).every(item => {
        return this.hasProvide.map(i => i.imageType).includes(item)
      })
    },
    showCard () {
      return ['ID_CARD_FRONT', 'ID_CARD_BACK', 'HOLDING_ID_CARD_PHOTO'].some(item => this.needProvide.includes(item))
    },
    showOther () {
      return ['PAYMENT_CARD_PHOTO', 'LOAN_HISTORY_SCREEN'].some(item => this.needProvide.includes(item))
    },
    otherReady () {
      return this.needProvide.filter(ai => ['PAYMENT_CARD_PHOTO', 'LOAN_HISTORY_SCREEN'].includes(ai)).every(item => {
        return this.hasProvide.map(i => i.imageType).includes(item)
      })
    }
  },

  methods: {
    ...mapActions('modify', ['getChangeConfig', 'commit']),
    async getConfig () {
      const { success, data } = await this.getChangeConfig()
      if (success) {
        this.needProvide = data.needProvide || []
        this.hasProvide = data.hasProvide || []
        this.mobileChangeInfo = data.mobileChangeInfo || {}
        this.contactsChangeInfo = data.contactsChangeInfo || []
        // this.hasProvide = [
        //   { imageType: 'ID_CARD_FRONT' },
        //   { imageType: 'ID_CARD_BACK' },
        //   { imageType: 'HOLDING_ID_CARD_PHOTO' },
        //   { imageType: 'PAYMENT_CARD_PHOTO' },
        //   { imageType: 'LOAN_HISTORY_SCREEN' }
        // ]
      }
    },
    async next () {
      const { success } = await this.commit()
      if (success) {
        this.$router.push('/modify/result')
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.modify-page {
  min-height: 100vh;
  padding-bottom: 20px;

  .divider {
    border-top: 20px solid #f8f8f8;
    height: 0px;
    font-size: 0px;
  }
  .info-img{
    width:calc(100% - 80px) ;
    margin: 0 40px;
  }
  .protocol {
    line-height: 32px;
    font-size: 24px;
    padding: 0 50px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    margin-top: 20px;
    .text {
      display: flex;
      position: relative;
      color: @fc3;
    }

    .indent {
      display: flex;
      display: inline-block;
      align-items: center;
      padding-left: 15px;
      > img {
        width: 32px;
        height: 32px;
        margin-right: 8px;
      }
    }

    .active {
      color: #8eb2d8;
    }
  }
  .step-title {
    display: flex;
    flex-direction: column;
    padding: 30px 40px;
    & > img {
      width: 670px;
      height: 76px;
    }

    h2 {
      font-size: 42px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      margin-top: 50px;
    }

    p {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      margin-top: 15px;
    }

    span {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
    }
  }
  .control-box {
    position: fixed;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.04);
    bottom: 0;
    left: 0;
    height: 240px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    left: 50%;
    width: 100%;
    transform: translateX(-50%);
  }

  .add-list {
    padding: 30px 40px;
    .item {
      border: 1px solid #cccccc;
      border-radius: 10px;
      margin-bottom: 20px;
      overflow: hidden;
    }
    & .gray-text {
      color: #aaa;
    }
  }
}
</style>
